import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  paper: {
    padding: "4px 0",
    borderRadius: 6
  },
  menuItem: {
    width: 248,
    height: 44,
    padding: "0 0 0 20px",
    display: "flex",
    justifyContent: "flex-start",
    textTransform: "capitalize"
  },
  menuItemIcon: {
    minWidth: 40
  }
});
